export type GenerativeFrame = Record<string, string>;

type CssPropertyReader = {
  getPropertyValue(name: string): string;
};

/** Read the complete animation frame that a static export must reproduce. */
export function readGenerativeFrame(
  style: CssPropertyReader,
  gradientCount: number,
  initialFrame: GenerativeFrame
): GenerativeFrame {
  if (!Number.isInteger(gradientCount) || gradientCount < 1) {
    throw new Error(
      `Generative gradient count must be a positive integer, received ${gradientCount}`
    );
  }

  const frame: GenerativeFrame = {};
  for (let index = 1; index <= gradientCount; index++) {
    for (const axis of ["x", "y", "h"]) {
      const name = `--${axis}${index}`;
      const value = style.getPropertyValue(name).trim() || initialFrame[name]?.trim();
      if (!value) throw new Error(`Generative frame is missing ${name}`);
      frame[name] = value;
    }
  }
  return frame;
}
